export class SampleBoardConstructionInstructions {
    public id: string;
    public name: string;
    public url: string;

    constructor(ticketReport: any = {}) {
        this.id = ticketReport.id;
        this.name = ticketReport.name;
        this.url = ticketReport.url;
    }
}
